module.exports = {
  logToDataLayer(eventObject) {
    if (window.dataLayer) {
      window.dataLayer.push(eventObject);
    }
  },
};
